<template>
  <el-tooltip
      class="item"
      effect="dark"
      content="Refresh data"
      placement="top">
    <a @click="refreshProducts()"><i :class="iconClass"></i></a>
  </el-tooltip>
</template>

<script>
export default {
  name: "RefreshProducts",
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    iconClass() {
      return this.loading ? "el-icon-loading" : "el-icon-refresh";
    },
  },
  methods: {
    refreshProducts() {
      this.loading = true;
      this.$store.dispatch("shared/fetchProducts").finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped></style>
